export default "/_next/static/images/img1-5ce06349eeb3e041beaf23d695fe0f29.png";